// src/components/Roadmap.jsx
import React from 'react';
import './Roadmap.css';
import MessageBox from './MessageBox'; // ✅ Import MessageBox component

const Roadmap = () => (
  <>
    {/* ✅ MessageBox at Top like ConnectWallet */}
    <MessageBox
      icon="🤖"
      text="VORTREX is real-time orderbook AI — trading live across global exchanges."
    />

    <div className="roadmap-container">
      <div className="heading">TRADING SYSTEM</div>
      <div className="subheading">📊 From Orderbooks to Execution – Trade Smarter, Not Harder</div>
      <div className="timeline">

        <div className="timeline-box">
          <div className="quarter">⚙️ Core Launch</div>
          <div className="desc">VORTREX is now a high-performance AI trading bot for BTC Futures, Gold, and other major assets. Engineered for real-time execution using orderbook intelligence.</div>
        </div>

        <div className="timeline-box">
          <div className="quarter">🔌 Multi-Exchange Orderbook Intelligence</div>
          <div className="desc">The bot aggregates full orderbook data from Binance, Bybit, OKX, Bitget, Coinbase Pro, Kraken, and more to detect spoof zones, bid/ask pressure, and liquidity flow in real-time.</div>
        </div>

        <div className="timeline-box">
          <div className="quarter">🧠 AI Execution Engine</div>
          <div className="desc">ML models detect optimal entries/exits using orderbook imbalance, momentum shifts, and tape signals. Auto Take-Profit and Stop-Loss are included per trade.</div>
        </div>

        <div className="timeline-box">
          <div className="quarter">🔒 Built-In Risk Protection</div>
          <div className="desc">AI-adjusted SL/TP protection adapts to volatility and trend strength. Includes breakeven logic, trailing SL, and multi-tiered TP targets.</div>
        </div>

        <div className="timeline-box">
          <div className="quarter">📊 Your Command Center</div>
          <div className="desc">Real-time dashboard for live trades, PnL logs, exchange heatmaps, sentiment index, and orderbook snapshots — all in one place.</div>
        </div>

        <div className="timeline-box">
          <div className="quarter">🌍 Expanding Asset Universe</div>
          <div className="desc">Supports more than just BTC — including Gold, Silver, Nasdaq, Oil, and major Forex pairs using the same VORTREX engine.</div>
        </div>

        <div className="timeline-box">
          <div className="quarter">🛠️ Custom Strategy Builder (Coming Soon)</div>
          <div className="desc">Create your own AI strategy using indicators like RSI, VWAP, depth walls, and launch bots with your logic using drag-and-drop tools.</div>
        </div>

        <div className="timeline-box">
          <div className="quarter">⏪ Backtesting & Replay Suite</div>
          <div className="desc">Replay real market days using historical orderbook data. Simulate strategies with full transparency before going live.</div>
        </div>

        <div className="timeline-box">
          <div className="quarter">🧬 Self-Evolving Intelligence</div>
          <div className="desc">Bot continuously learns from its performance. Models retrain weekly using XGBoost, LSTM, and real-time feedback to improve accuracy.</div>
        </div>

        <div className="timeline-box">
          <div className="quarter">🚀 API Access for Institutions</div>
          <div className="desc">Pro-level API access for quant traders, hedge funds, and algorithmic strategies. Includes signal feed, trade triggers, and raw execution pipeline.</div>
        </div>

      </div>
    </div>
  </>
);

export default Roadmap;
